import { useEffect, useState } from "react";
import { useAuth } from "../../hooks/auth";
import { RaceBy } from "@uiball/loaders";
import Title from "../../components/Title";
import { isEmpty } from "../../utils/functions";
import ModalVerRespuestas from "../../components/Modals/Encuestas/verRespuestas";
import listarResultadosEncuestas from "../../services/admin/encuestas/resultados";
import obtenerResultadoEncuesta from "../../services/admin/encuestas/obtenerResultado";
import { CURRENT_DATE } from "../../utils/config";

const hace30Dias = () => {
    const d = new Date();
    d.setDate(d.getDate() - 30);
    return d.toISOString().split('T')[0];
};

export default function ResultadosEncuestas() {
    const { token } = useAuth();
    const [resultados, setResultados] = useState([]);
    const [mensaje, setMensaje] = useState('');
    const [loading, setLoading] = useState(true);
    const [desde, setDesde] = useState(hace30Dias());
    const [hasta, setHasta] = useState(CURRENT_DATE);
    const [verModal, setVerModal] = useState(false);
    const [seleccionado, setSeleccionado] = useState(null);
    const [loadingDetalle, setLoadingDetalle] = useState(false);

    const cargar = () => {
        setLoading(true);
        setMensaje('');
        listarResultadosEncuestas({
            token, desde, hasta, callbacks: response => {
                setLoading(false);
                if (response.estado > 0) {
                    if (response.resultados.length > 0) {
                        setResultados(response.resultados);
                    } else {
                        setResultados([]);
                        setMensaje('No hay encuestas respondidas en el período seleccionado.');
                    }
                } else {
                    setMensaje(response.mensaje || 'Error al cargar los resultados.');
                }
            }
        });
    };

    useEffect(() => { cargar(); }, [token]);

    const verDetalle = (id) => {
        setSeleccionado(null);
        setLoadingDetalle(true);
        setVerModal(true);
        obtenerResultadoEncuesta({
            token, id, callbacks: response => {
                setLoadingDetalle(false);
                if (response.estado > 0) {
                    setSeleccionado(response.resultado);
                } else {
                    setVerModal(false);
                }
            }
        });
    };

    const formatFecha = (fecha) => {
        if (!fecha) return '-';
        return new Date(fecha).toLocaleString('es-AR', { dateStyle: 'short', timeStyle: 'short' });
    };

    return (
        <>
            <main>
                <div className="container-fluid ps-0">
                    <div className="glassDatos">
                        <div className="pb-4 d-flex align-items-center justify-content-between flex-wrap gap-2">
                            <Title title="Resultados de encuestas" class="titlegray" />
                            <div className="d-flex align-items-end gap-2 flex-wrap">
                                <div>
                                    <label className="form-label mb-1 small text-muted">Desde</label>
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        value={desde}
                                        onChange={e => setDesde(e.target.value)}
                                    />
                                </div>
                                <div>
                                    <label className="form-label mb-1 small text-muted">Hasta</label>
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        value={hasta}
                                        onChange={e => setHasta(e.target.value)}
                                    />
                                </div>
                                <button className="btn-orange px-4" style={{ height: '31px', minWidth: 'unset', width: 'auto' }} onClick={cargar}>
                                    Filtrar
                                </button>
                            </div>
                        </div>

                        {loading ? (
                            <div className="position-absolute containerLoading">
                                <RaceBy size={280} lineWeight={15} speed={1.4} color="black" />
                            </div>
                        ) : (
                            <table className="table table-striped table-hover">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Encuesta</th>
                                        <th>Colaborador</th>
                                        <th>Sucursal</th>
                                        <th>Motivo</th>
                                        <th>Fecha respuesta</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!isEmpty(mensaje) ? (
                                        <tr>
                                            <td colSpan={7}>
                                                <div className="alert alert-info mb-0">{mensaje}</div>
                                            </td>
                                        </tr>
                                    ) : (
                                        resultados.map(item => (
                                            <tr key={item.encuesta_id}>
                                                <td>#{item.encuesta_id}</td>
                                                <td>{item.formulario_nombre || '-'}</td>
                                                <td>
                                                    {item.persona_nombre} {item.persona_apellido}
                                                    {item.persona_dni && <small className="text-muted ms-1">({item.persona_dni})</small>}
                                                </td>
                                                <td>{item.sucursal_nombre || '-'}</td>
                                                <td>{item.motivo_turno_nombre || '-'}</td>
                                                <td>{formatFecha(item.fecha_respuesta)}</td>
                                                <td>
                                                    <button className="btnDerivar px-3" onClick={() => verDetalle(item.encuesta_id)}>
                                                        Ver
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </main>

            <ModalVerRespuestas
                resultado={seleccionado}
                loading={loadingDetalle}
                ver_modal={verModal}
                setModal={setVerModal}
            />
        </>
    );
}
